interface LoadingProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
  fullScreen?: boolean;
}

const sizeStyles = {
  sm: 'h-6 w-6',
  md: 'h-10 w-10',
  lg: 'h-16 w-16',
};

export const Loading = ({
  size = 'md',
  message = '読み込み中...',
  fullScreen = false,
}: LoadingProps) => {
  const content = (
    <div className="flex flex-col items-center justify-center gap-4">
      <div
        className={`
          ${sizeStyles[size]}
          animate-spin rounded-full
          border-4 border-gray-200 border-t-line
        `}
      />
      {message && <p className="text-gray-600 text-sm">{message}</p>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white/80 flex items-center justify-center z-50">
        {content}
      </div>
    );
  }

  return content;
};

export default Loading;
